import React from 'react';
import { connect } from 'react-redux';

// Components
import { Col, Icon, Layout, Menu, Row } from 'antd';
import { NavLink } from 'react-router-dom';
import EditUserModal from '../auth/EditUserModal';
import ChangePasswordModal from '../auth/ChangePasswordModal';

import { onChangePasswordModalIsShown, onEditModalIsShown } from '../../data/auth/actions';

// Selectors
import {
    getUserChangePasswordModalIsShown,
    getUserCompany,
    getUserEditModalIsShown,
    getUserName,
    getUserSurName,
    isRoleAdministrator,
} from '../../data/auth/selectors';

// Other
import logoSVG from '../../../assets/images/logoFullColorized.svg';
import { ROUTE_NAMES } from '../../utils';
import { LANDING_HOST } from '../../utils/api/constants';

const Navbar = ({
    protectedRoutes,
    loggedUserName,
    activePath,
    isAuthenticated,
    isRoleAdmin,
    msgs,
    logout,
    editModalIsShown,
    onEditModalIsShown,
    onChangePasswordModalIsShown,
    changePasswordModalIsShown,
    company,
}) => (
    <React.Fragment>
        <Layout.Header style={{ background: '#fff', minHeight: 64, height: 'auto' }}>
            <Row>
                <Col xs={24} sm={24} md={3} lg={2}>
                    <a data-testid="logolink" href={LANDING_HOST} style={{ display: 'block', textAlign: 'center' }}>
                        <img
                            src={logoSVG}
                            alt="logo"
                            style={{ position: 'relative', height: 35, top: -5, marginRight: 30 }}
                        />
                    </a>
                </Col>
                <Col xs={24} sm={24} md={11} lg={11} style={{zIndex: 1000}}>
                    <Menu
                        mode="horizontal"
                        selectedKeys={[activePath]}
                        style={{ lineHeight: '64px' }}
                    >
                        {protectedRoutes &&
                            isAuthenticated &&
                            protectedRoutes.length > 0 &&
                            protectedRoutes.map(route => {
                                if (!isRoleAdmin && route.path === ROUTE_NAMES.ADMIN_USERS) return null;

                                return (
                                    <Menu.Item key={route.path}>
                                        <NavLink data-testid={`link[${route.path}]`} to={route.path}>
                                            {route.sidebar}
                                        </NavLink>
                                    </Menu.Item>
                                );
                            })}
                    </Menu>
                </Col>
                <Col xs={24} sm={24} md={10} lg={11}>
                    <Menu
                        mode="horizontal"
                        style={{ lineHeight: '64px', float: 'right' }}
                    >
                        {isAuthenticated && loggedUserName && (
                            <Menu.Item key="logged-as" onClick={() => onEditModalIsShown(true)}>
                                {company ? `${loggedUserName  } - ${  company}` : `${loggedUserName }`}
                            </Menu.Item>
                        )}
                        {isAuthenticated && (
                            <Menu.Item key="change-pass" onClick={() => onChangePasswordModalIsShown(true)}>
                                {msgs.auth.changePassword}
                                <Icon style={{ paddingLeft: `1em` }} type="key" />
                            </Menu.Item>
                        )}
                        {isAuthenticated && (
                            <Menu.Item key="logout-link" onClick={logout}>
                                <Icon type="logout" />
                                &nbsp;
                                {msgs.logoutLink}
                            </Menu.Item>
                        )}
                    </Menu>
                </Col>
            </Row>
        </Layout.Header>
        {editModalIsShown && <EditUserModal msgs={msgs} onCancel={() => onEditModalIsShown(false)} />}
        {changePasswordModalIsShown && <ChangePasswordModal msgs={msgs} onCancel={() => onChangePasswordModalIsShown(false)} />}
    </React.Fragment>
);

export default connect(
    state => ({
        loggedUserName: `${getUserName(state)} ${getUserSurName(state)}`,
        isRoleAdmin: isRoleAdministrator(state),
        isAuthenticated: state.auth.get('isAuthorized'),
        activePath: state.router.location.pathname,
        editModalIsShown: getUserEditModalIsShown(state),
        changePasswordModalIsShown: getUserChangePasswordModalIsShown(state),
        company: getUserCompany(state),
    }),
    {
        onEditModalIsShown,
        onChangePasswordModalIsShown
    }
)(Navbar);
